import {View} from '@react-pdf/renderer';
import {TFunction} from 'i18next';

import {Suggestions} from './Suggestions';
import {ScreeningRecommendations} from '../../../../../../types/ApplicantScreeningReport';
import {SupportedLanguages} from '../../../../../../types/SupportedLanguages';

interface Props {
  suggestions: ScreeningRecommendations[];
  lang: SupportedLanguages;
  t: TFunction;
}

export const DeepDiveSection = ({suggestions, lang, t}: Props) => {
  return (
    <View style={{display: 'flex', flexDirection: 'column', gap: 16}}>
      {suggestions.map((interviewSuggestions) => (
        <Suggestions
          key={interviewSuggestions.pillarTitle[lang]}
          interviewSuggestions={interviewSuggestions}
          lang={lang}
          t={t}
        />
      ))}
    </View>
  );
};
